import React from 'react'
import styles from './styles/search-bar.module.scss'
import classNames from 'classnames'
import WTNSpinner from 'components/generic/WTNSpinner'
import { ReactComponent as ErrorSign } from 'images/icons/icn_large_error.svg'

interface Props {
  loading?: boolean
  error?: boolean
}

const SearchBarPlaceholder = ({ loading, error }: Props) => {
  const placeholderText = error ? 'application error' : 'loading...'
  return (
    <div className={styles.inputSuggestionWrapper}>
      <div className={styles.searchInputWrapper}>
        <div className={styles.searchBarPlaceholder}>
          <div className={styles.searchBarPlaceholderIconContainer}>
            {error ? (
              <ErrorSign className={styles.searchBarPlaceholderIconError} />
            ) : (
              <WTNSpinner width={30} />
            )}
          </div>
          <span
            className={classNames(styles.searchBarPlaceholderText, {
              [styles.searchBarPlaceholderTextError]: error,
            })}
          >
            {placeholderText}
          </span>
        </div>
      </div>
    </div>
  )
}

export default SearchBarPlaceholder
